module.exports = __webpack_public_path__ + "static/media/icon-file-plus.33187087.svg";